import type { Printer } from '@/services/productService';

type CandidateItem = {
  readonly id: string;
  readonly printerId?: string | null;
};

interface AutoAssignOptions {
  readonly getPrinters: () => Promise<Printer[]>;
  readonly eligibleIds: ReadonlySet<string>;
  readonly items: ReadonlyArray<CandidateItem>;
  readonly onAssign: (orderItemIds: string[], printerId: string) => Promise<void> | void;
}

export const autoAssignSinglePrinter = async ({
  getPrinters,
  eligibleIds,
  items,
  onAssign,
}: AutoAssignOptions): Promise<{ printerId: string | null; orderItemIds: string[] }> => {
  const printers = await getPrinters();
  if (printers.length !== 1) {
    return { printerId: null, orderItemIds: [] };
  }

  const singlePrinterId = printers[0]?.id ?? null;
  if (!singlePrinterId) {
    return { printerId: null, orderItemIds: [] };
  }

  const orderItemIds = items
    .filter(item => item?.id && eligibleIds.has(item.id) && !item.printerId)
    .map(item => item.id);

  if (orderItemIds.length === 0) {
    return { printerId: singlePrinterId, orderItemIds: [] };
  }

  await onAssign(orderItemIds, singlePrinterId);
  return { printerId: singlePrinterId, orderItemIds };
};
